import { Module } from 'vuex';
import { IDeleteFieldState } from './delete-field.types';
import { RootState } from '@/store/store';
import { actions } from '@/document-edit/assembler/fields/delete/store/delete-field.actions';
import { mutations } from '@/document-edit/assembler/fields/delete/store/delete-field.mutations';
import { state } from '@/document-edit/assembler/fields/delete/store/delete-field.constants';

export const deleteField: Module<IDeleteFieldState, RootState> = {
  actions,
  mutations,
  state,
  namespaced: true,
};
